import {
    type GetAllDriveFoldersResponseType,
    type GetAllDriveFoldersRequestType
} from "./type";
import {
    request
} from "../request";

const GetAllDriveFolders = async (params: GetAllDriveFoldersRequestType): Promise<GetAllDriveFoldersResponseType> => {
    return await request<GetAllDriveFoldersResponseType>("/drive/getAllDriveFolders", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetAllDriveFolders;
